export const BUSINESS_CRITICAL_CACHE = {
  asset: 'business-critical-assets',
  html: 'business-critical-pages',
  image: 'business-critical-images',
  rsc: 'business-critical-rsc',
} as const;

export const BUSINESS_CRITICAL_MAX_AGE_MS = 24 * 60 * 60 * 1000;

export const OFFLINE_WARM_BUILD_KEY = 'mdrt.offline-warm-build';
